import React from 'react';
import DataTable from 'react-data-table-component';
import Loader from '../../../components/Loader';
import useTopTable from '../../../hooks/admin/useTopTable';

const TopTable = ({ type, company }) => {
  const { columns, data, loading } = useTopTable({ company }, type);

  if (loading) return <Loader />;
  return (
    <DataTable
      title={`Top ${type === 'foundation' ? 'Fundaciones' : 'Campañas'}`}
      columns={columns}
      data={data}
      className='table'
    />
  );
};
export default TopTable;
